import { __extends } from "tslib";
import { AssetEvent, LoaderEvent, AssetLibrary, URLRequest, URLLoaderEvent, RequestAnimationFrame, AudioManager, PerspectiveProjection, CoordinateSystem, ColorUtils, Loader, WaveAudioParser, EventDispatcher, Point, } from '@awayjs/core';
import { DisplayObjectContainer, FrameScriptManager, MouseManager, DefaultFontManager, } from '@awayjs/scene';
import { BitmapImage2D, Image2DParser, TouchPoint } from '@awayjs/stage';
import { BasicPartition, PickGroup, View } from '@awayjs/view';
import { DefaultRenderer, RenderGroup } from '@awayjs/renderer';
import { MovieClipSoundsManager } from './factories/timelinesounds/MovieClipSoundsManager';
import { StageScaleMode } from './factories/as3webFlash/display/StageScaleMode';
import { StageAlign } from './factories/as3webFlash/display/StageAlign';
import { AVMVERSION } from './factories/base/AVMVersion';
import { AVMTestHandler } from './AVMTestHandler';
import { SWFParser } from './parsers/SWFParser';
import { AVMEvent } from './AVMEvent';
import { globalRedirectRules } from './redirectResolver';
function parseRelative(value, from) {
    // not require replace %, parsefloat MUST (by spec) ignore it
    if (typeof value === 'string' && value.includes('%')) {
        return from * parseFloat(value) / 100;
    }
    return +value;
}
var AVMStage = /** @class */ (function (_super) {
    __extends(AVMStage, _super);
    function AVMStage(gameConfig) {
        var _this = _super.call(this) || this;
        _this._trapResize = false;
        _this._volume = 1;
        _this._gameConfig = null;
        _this._curFile = null;
        _this._requestedRender = false;
        //if (AVMStage._instance)
        //	throw ('Only one AVMStage is allowed to be constructed');
        AVMStage._instance = _this;
        Loader.enableParsers([WaveAudioParser, SWFParser, Image2DParser]);
        _this._time = 0;
        _this._currentFps = 0;
        _this._avmHandlers = {};
        _this._baseStageWidth = _this._stageWidth = 550;
        _this._baseStageHeight = _this._stageHeight = 400;
        _this._scaleMode = StageScaleMode.SHOW_ALL;
        _this._align = StageAlign.TOP_LEFT;
        _this._scaleModeAllowUpdate = true;
        _this._alignAllowUpdate = true;
        if (gameConfig.stageScaleMode) {
            _this._scaleMode = gameConfig.stageScaleMode;
            _this._scaleModeAllowUpdate = false;
        }
        if (gameConfig.stageAlign) {
            _this._align = gameConfig.stageAlign;
            _this._alignAllowUpdate = false;
        }
        if (gameConfig.forceINT) {
            AVMStage.forceINT = gameConfig.forceINT;
        }
        _this._frameRate = 30;
        _this._showFrameRateIntervalID = -1;
        _this._x = gameConfig.x ? gameConfig.x : 0;
        _this._y = gameConfig.y ? gameConfig.y : 0;
        _this._w = gameConfig.w ? gameConfig.w : '100%';
        _this._h = gameConfig.h ? gameConfig.h : '100%';
        _this._isPaused = false;
        _this._gameConfig = gameConfig;
        // init awayengine
        _this.initAwayEninge();
        _this._renderer.view.backgroundColor = 0xffffff;
        //this._stage3Ds[this._stage3Ds.length]=new AwayStage(null, );
        AudioManager.setVolume(1);
        // resize event listens on window
        _this._resizeCallbackDelegate = function (event) { return _this.resizeCallback(event); };
        window.addEventListener('resize', _this._resizeCallbackDelegate);
        _this._onLoaderStartDelegate = function (event) { return _this.onLoaderStart(event); };
        _this._onLoaderCompleteDelegate = function (event) { return _this.onLoaderComplete(event); };
        _this._onAssetCompleteDelegate = function (event) { return _this._onAssetComplete(event); };
        _this._onLoadErrorDelegate = function (event) { return _this._onLoadError(event); };
        if (_this._gameConfig.testConfig) {
            _this.avmTestHandler = new AVMTestHandler(_this._gameConfig.testConfig, _this);
        }
        _this.showFrameRate = _this._gameConfig.showFPS;
        document.addEventListener('fullscreenchange', _this.onFullscreenChanged.bind(_this));
        return _this;
    }
    AVMStage.instance = function () {
        if (!AVMStage._instance)
            throw ('AVMStage._instance should exists but does not');
        return AVMStage._instance;
    };
    Object.defineProperty(AVMStage.prototype, "factory", {
        get: function () {
            return this._avmHandler.factory;
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.prototype.dispose = function () {
        console.log('dispose');
        this._timer.stop();
        this._timer = null;
        this._avmHandler.dispose();
    };
    Object.defineProperty(AVMStage.prototype, "root", {
        get: function () {
            return this._root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "rootNode", {
        get: function () {
            return this._rootNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "pickGroup", {
        get: function () {
            return this._pickGroup;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "mousePicker", {
        get: function () {
            return this._mousePicker;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "mouseManager", {
        get: function () {
            return this._mouseManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "config", {
        get: function () {
            return this._gameConfig;
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.prototype.registerAVMStageHandler = function (value) {
        this._avmHandlers[value.avmVersion] = value;
    };
    Object.defineProperty(AVMStage.prototype, "displayState", {
        get: function () {
            return this._displayState;
        },
        set: function (v) {
            var _this = this;
            if (!document.fullscreenEnabled) {
                this._displayState = "normal" /* StageDisplayState.NORMAL */;
                return;
            }
            switch (v) {
                case "fullScreenInteractive" /* StageDisplayState.FULL_SCREEN_INTERACTIVE */:
                case "fullScreen" /* StageDisplayState.FULL_SCREEN */:
                    if (Element.prototype.requestFullscreen) {
                        document.body.requestFullscreen().then(function () {
                            _this._displayState = v;
                        });
                    }
                    break;
                default:
                    this._displayState = v;
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    }
            }
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.prototype.onFullscreenChanged = function (_e) {
        if (!document.fullscreenElement) {
            this._displayState = "normal" /* StageDisplayState.NORMAL */;
        }
    };
    AVMStage.prototype.initAwayEninge = function () {
        //create the projection
        this._projection = new PerspectiveProjection();
        this._projection.coordinateSystem = CoordinateSystem.RIGHT_HANDED;
        this._projection.originX = -1;
        this._projection.originY = 1;
        this._projection.transform.moveTo(0, 0, -1000);
        this._projection.fieldOfView = Math.atan(window.innerHeight / 1000 / 2) * 360 / Math.PI;
        //create the partition
        this._view = new View(this._projection);
        this._root = new DisplayObjectContainer();
        this._root.partitionClass = BasicPartition;
        this._rootNode = this._root.getAbstraction(this._view);
        this._partition = this._rootNode.partition;
        //create the pickers
        this._pickGroup = PickGroup.getInstance();
        this._mousePicker = this._pickGroup.getRaycastPicker(this._partition);
        this._mousePicker.shapeFlag = true;
        this._mouseManager = MouseManager.getInstance(this._view.stage);
        //create the renderer
        this._renderer = this._partition.getAbstraction(RenderGroup.getInstance(DefaultRenderer));
        this._rendererStage = this._view.stage;
        this._rendererStage.container.style.visibility = 'hidden';
        this._rendererStage.antiAlias = 0;
        this._renderer.renderableSorter = null; //new RenderableSort2D();
    };
    AVMStage.prototype.playSWF = function (buffer, url) {
        var _this = this;
        this._gameConfig = {
            files: [{ data: buffer, path: url, resourceType: "GAME" /* ResourceType.GAME */ }],
        };
        this.addEventListener(LoaderEvent.LOADER_COMPLETE, function (_e) { return _this.play(); });
        this.loadNextResource();
    };
    AVMStage.prototype.snapshot = function (callback) {
        var myBitmap = new BitmapImage2D(this._stageWidth, this._stageHeight, true, 0xffffffff, false);
        this._renderer.queueSnapshot(myBitmap);
        this._renderer.view.target = myBitmap;
        this._renderer.render();
        this._renderer.view.target = null;
        myBitmap.invalidate();
        // flip vertical:
        var oldData = myBitmap.data;
        var myBitmap2 = new BitmapImage2D(this._stageWidth, this._stageHeight, true, 0xff00ffff, false);
        var idx = 0;
        var color = 0;
        for (var y = 0; y < this._stageHeight; y++) {
            for (var x = 0; x < this._stageWidth; x++) {
                idx = ((this._stageHeight - 1 - y) * this._stageWidth + x) * 4;
                color = ColorUtils.ARGBtoFloat32(oldData[idx + 3], oldData[idx], oldData[idx + 1], oldData[idx + 2]);
                myBitmap2.setPixel32(x, y, color);
            }
        }
        myBitmap2.invalidate();
        var htmlCanvas = document.createElement('canvas');
        htmlCanvas.width = myBitmap2.width;
        htmlCanvas.height = myBitmap2.height;
        /*htmlCanvas.style.position = "absolute";
        htmlCanvas.style.top = "0px";
        htmlCanvas.style.left = "0px";
        htmlCanvas.style.width = "100%";*/
        var context = htmlCanvas.getContext('2d');
        var imageData = context.getImageData(0, 0, myBitmap2.width, myBitmap2.height);
        imageData.data.set(myBitmap2.data);
        context.putImageData(imageData, 0, 0);
        if (callback)
            callback(htmlCanvas);
    };
    AVMStage.prototype.loadNextResource = function (event) {
        var _this = this;
        if (event === void 0) { event = null; }
        this._curFile = this._gameConfig.files.shift();
        if (this._curFile) {
            var parser_1 = new SWFParser();
            parser_1.fileName = this._curFile.path;
            if (this._curFile.resourceType != "GAME" /* ResourceType.GAME */) {
                DefaultFontManager.deviceFontsLoading = true;
            }
            else {
                DefaultFontManager.deviceFontsLoading = false;
                if (this._swfFile) {
                    throw 'Only playing of 1 SWF file is supported at the moment';
                }
                parser_1.onFactoryRequest = function (swfFile) {
                    _this._swfFile = swfFile;
                    _this.frameRate = _this._swfFile.frameRate;
                    // todo: these values should already been modded in the parser:
                    _this.color = ColorUtils.f32_RGBA_To_f32_ARGB(swfFile.backgroundColor);
                    _this._stageWidth = _this._swfFile.bounds.width / 20;
                    _this._stageHeight = _this._swfFile.bounds.height / 20;
                    _this._baseStageHeight = _this._stageHeight;
                    _this._baseStageWidth = _this._stageWidth;
                    _this.resizeCallback();
                    var avmName = _this._swfFile.useAVM1 ? AVMVERSION.AVM1 : AVMVERSION.AVM2;
                    _this._avmHandler = _this._avmHandlers[avmName];
                    if (_this.avmTestHandler && !_this.avmTestHandler.config.settings.onlyTraces) {
                        /*if(this._swfFile.useAVM1){
                            // in FP when using the shell.swf, avm1 traces are 1 frame behind
                            // so we mimmic that behavior here
                            this.avmTestHandler.nextFrame();
                        }*/
                        _this.avmTestHandler.setSWF(_this._swfFile);
                    }
                    if (!_this._avmHandler) {
                        throw 'no avm-handler installed for ' + avmName;
                    }
                    _this._avmHandler.init(_this, _this._swfFile, function (hasInit) {
                        parser_1.factory = _this._avmHandler.factory;
                        SWFParser.factory = _this._avmHandler.factory;
                        if (hasInit)
                            _this.dispatchEvent(new AVMEvent(AVMEvent.AVM_COMPLETE, avmName));
                    });
                };
            }
            // Parser will not be provided with factory. DefaultSceneGraphFactory will be used
            AssetLibrary.addEventListener(LoaderEvent.LOADER_START, this._onLoaderStartDelegate);
            AssetLibrary.addEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
            AssetLibrary.addEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
            AssetLibrary.addEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
            if (this._curFile.data) {
                AssetLibrary.loadData(this._curFile.data, null, this._curFile.path, parser_1);
            }
            else {
                AssetLibrary.load(new URLRequest(this._curFile.path), null, this._curFile.path, parser_1);
            }
        }
        else {
            if (!this._swfFile) {
                throw 'no valid SWFFile was loaded!';
            }
            if (event) {
                this.dispatchEvent(event);
            }
        }
    };
    AVMStage.prototype.load = function () {
        if (!this._gameConfig.files || !this._gameConfig.files.length) {
            throw ('AVMStage: gameConfig.files must have positive length');
        }
        globalRedirectRules.push.apply(globalRedirectRules, this._gameConfig.redirects);
        this.loadNextResource(new LoaderEvent(LoaderEvent.LOADER_COMPLETE));
    };
    AVMStage.prototype.onLoaderStart = function (event) {
        this.dispatchEvent(event);
    };
    AVMStage.prototype._onAssetComplete = function (event) {
        // atm we only addAssets to avmHandler that come from the game swf
        // preloaded files are fonts, and are handled by DefaultManager outside of SWF
        if (this._curFile.resourceType == "GAME" /* ResourceType.GAME */) {
            if (AVMStage.runtimeStartTime == 0) {
                AVMStage.runtimeStartTime = Date.now();
            }
            this._avmHandler.addAsset(event.asset, true);
        }
        this.dispatchEvent(event);
    };
    AVMStage.prototype.onLoaderComplete = function (event) {
        if (this._root)
            this._root.dispatchEvent(event);
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        this.loadNextResource(event);
    };
    AVMStage.prototype._onLoadError = function (event) {
        AssetLibrary.removeEventListener(AssetEvent.ASSET_COMPLETE, this._onAssetCompleteDelegate);
        AssetLibrary.removeEventListener(LoaderEvent.LOADER_COMPLETE, this._onLoaderCompleteDelegate);
        AssetLibrary.removeEventListener(URLLoaderEvent.LOAD_ERROR, this._onLoadErrorDelegate);
        console.log('error loading swf');
        this.dispatchEvent(event);
    };
    AVMStage.prototype.play = function (offset) {
        if (offset === void 0) { offset = 0; }
        // start the main_loop:
        this.resizeCallback(null);
        this._timer = new RequestAnimationFrame(this.main_loop, this);
        this._timer.start();
        var rootMC = this._root.getChildAt(0);
        if (!rootMC) {
            console.warn('warning: AVMPlayer.play called, but no scene is loaded');
            return;
        }
        if (offset) {
            rootMC.currentFrameIndex = offset;
        }
        // manually move playhead to next frame, so we immediatly render something
        this.showNextFrame(0);
        this._rendererStage.container.style.visibility = 'visible';
    };
    AVMStage.prototype.updateFPS = function () {
        this._fpsTextField.style.visibility = (!this._currentFps || !this._frameRate) ? 'hidden' : 'visible';
        this._fpsTextField.innerText = this._currentFps.toFixed(2) + '/' + this._frameRate + ' fps';
        this._currentFps = 0;
    };
    AVMStage.prototype.setStageDimensions = function (x, y, w, h) {
        this._x = x;
        this._y = y;
        this._w = w;
        this._h = h;
        this.resizeStageInternal();
    };
    AVMStage.prototype.resizeStageInternal = function (noEmitResize) {
        if (noEmitResize === void 0) { noEmitResize = false; }
        var x = parseRelative(this._x, window.innerWidth);
        var y = parseRelative(this._y, window.innerHeight);
        var w = parseRelative(this._w, window.innerWidth);
        var h = parseRelative(this._h, window.innerHeight);
        // we should supress pixel ratio scaling for stage when there are scale limit
        var supressPixelRatio = !!this._gameConfig.maxStageScale;
        var maxScale = (+this._gameConfig.maxStageScale || 10);
        var maxWidth = maxScale * this._baseStageWidth;
        var maxHeight = maxScale * this._baseStageHeight;
        var aspect = this._baseStageWidth / this._baseStageHeight;
        var container = this._rendererStage.container;
        var dpi = supressPixelRatio ? self.devicePixelRatio : 1;
        var newX = x;
        var newY = y;
        var scaledWidth = w;
        var scaledHeight = h;
        // this is CSS bassed width/heigth, used for apply canvas style
        // real canvas size can be greater or less render dimension
        var targetWidth = w;
        var targetHeight = h;
        // todo: correctly implement all StageScaleModes;
        switch (this._scaleMode) {
            case StageScaleMode.NO_SCALE: {
                this._projection.fieldOfView = Math.atan(h / 1000 / 2) * 360 / Math.PI;
                this._stageWidth = w;
                this._stageHeight = h;
                break;
            }
            case StageScaleMode.SHOW_ALL: {
                targetHeight = h;
                targetWidth = aspect * h;
                scaledHeight = Math.min(maxHeight, targetHeight * dpi);
                scaledWidth = aspect * scaledHeight;
                if (targetWidth > w || scaledWidth > maxWidth) {
                    targetWidth = w;
                    targetHeight = w / aspect;
                    scaledWidth = Math.min(maxWidth, targetWidth * dpi);
                    scaledHeight = scaledWidth / aspect;
                }
                newX += (w - targetWidth) / 2;
                newY += (h - targetHeight) / 2;
                if (supressPixelRatio) {
                    // limit pixel ratio to 1 and supress auto scale
                    // now stage will ignore pixel ratio and will equal `scaledWidth`
                    this._rendererStage.pixelRatio = 1;
                }
                this._projection.fieldOfView = (Math.atan(this._stageHeight / 1000 / 2) * 360) / Math.PI;
                break;
            }
            case StageScaleMode.EXACT_FIT:
            case StageScaleMode.NO_BORDER:
                targetHeight = w / aspect;
                targetWidth = w;
                scaledWidth = Math.min(maxWidth, targetWidth * dpi);
                scaledHeight = scaledWidth / aspect;
                if (targetHeight < h || scaledHeight > maxHeight) {
                    targetWidth = h * aspect;
                    targetHeight = h;
                    scaledHeight = Math.min(maxHeight, targetHeight * dpi);
                    scaledWidth = scaledHeight * aspect;
                }
                newX += (w - targetWidth) / 2;
                newY += (h - targetHeight) / 2;
                if (supressPixelRatio) {
                    // limit pixel ratio to 1 and supress auto scale
                    // now stage will ignore pixel ratio and will equal `scaledWidth`
                    this._rendererStage.pixelRatio = 1;
                }
                this._projection.fieldOfView = (Math.atan(this._stageHeight / 1000 / 2) * 360) / Math.PI;
                break;
            default:
                console.log('Stage: only implemented StageScaleMode are NO_SCALE, SHOW_ALL');
                break;
        }
        // todo: correctly implement all alignModes;
        switch (this._align) {
            case StageAlign.TOP_LEFT:
                this._view.x = newX;
                this._view.y = newY;
                break;
            default:
                this._view.x = newX;
                this._view.y = newY;
                console.log('Stage: only implemented StageAlign is TOP_LEFT');
                break;
        }
        this._view.width = scaledWidth;
        this._view.height = scaledHeight;
        // override canvas dimension, we can scale down it
        // this is REQUIRED because stage set dimension relative scale
        container.style.width = targetWidth + 'px';
        container.style.height = targetHeight + 'px';
        if (this._fpsTextField)
            this._fpsTextField.style.left = (window.innerWidth * 0.5 - 50 + 'px');
        // we should not a emit resize event onto stage when property changed inside AVM
        if (this._avmHandler && !noEmitResize) {
            // we should emit resize in loop instead of immediate, prevent stack overflow
            this._trapResize = true;
        }
    };
    AVMStage.prototype.resizeCallback = function (_event) {
        if (_event === void 0) { _event = null; }
        this.resizeStageInternal();
    };
    AVMStage.prototype.pause = function () {
        // store default volume, because can be changed via game
        this._volume = AudioManager.getVolume();
        this._isPaused = true;
        AudioManager.setVolume(0);
    };
    AVMStage.prototype.unPause = function () {
        AudioManager.setVolume(this._volume);
        this._isPaused = false;
    };
    Object.defineProperty(AVMStage.prototype, "isPaused", {
        get: function () {
            return this._isPaused;
        },
        set: function (value) {
            this._isPaused = value;
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.prototype.main_loop = function (dt) {
        if (this._isPaused || !this._frameRate) {
            return;
        }
        if (this._trapResize) {
            this._avmHandler && this._avmHandler.resizeStage();
            this._trapResize = false;
        }
        if (!this._avmHandler) {
            throw ('error - can not render when no avm-stage is available');
        }
        var frameMarker = Math.floor(1000 / this._frameRate);
        this._time += Math.min(dt, frameMarker);
        if (this._time >= frameMarker) {
            this._currentFps++;
            this.showNextFrame(this._time);
            this._time -= frameMarker;
        }
        else if (this._requestedRender) {
            FrameScriptManager.execute_queue();
            this._renderer.render();
        }
        this._requestedRender = false;
    };
    AVMStage.prototype.requestRender = function () {
        this._requestedRender = true;
    };
    AVMStage.prototype.showNextFrame = function (dt) {
        if (this._isPaused) {
            MovieClipSoundsManager.enterFrame();
            MovieClipSoundsManager.exitFrame();
            return;
        }
        MovieClipSoundsManager.enterFrame();
        if (this.avmTestHandler)
            this.avmTestHandler.dispatchEvents();
        this._mouseManager.fireMouseEvents(this._mousePicker);
        this._avmHandler.enterFrame(dt);
        if (this.avmTestHandler)
            this.avmTestHandler.nextFrame();
        this._renderer.render();
        MovieClipSoundsManager.exitFrame();
    };
    Object.defineProperty(AVMStage.prototype, "align", {
        get: function () {
            return this._align;
        },
        set: function (value) {
            if (!this._alignAllowUpdate)
                return;
            this._align = value;
            this.resizeStageInternal(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "accessibilityImplementation", {
        get: function () {
            console.log('AVMStage: get accessibilityImplementation not implemented');
            return this._align;
        },
        set: function (_value) {
            //todo: any is AccessibilityImplementation
            console.log('AVMStage:  accessibilityImplementation not implemented');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "color", {
        get: function () {
            return this._renderer.view.backgroundColor;
        },
        set: function (value) {
            this._renderer.view.backgroundColor = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "frameRate", {
        get: function () {
            return this._frameRate;
        },
        set: function (value) {
            this._frameRate = value;
            MovieClipSoundsManager.frameRate = value;
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.prototype.getLocalMouseX = function (node) {
        return node
            .getInverseMatrix3D()
            .transformVector(this._renderer.view.unproject(this._view.stage.screenX, this._view.stage.screenY, 1000))
            .x;
    };
    AVMStage.prototype.getLocalMouseY = function (node) {
        return node
            .getInverseMatrix3D()
            .transformVector(this._renderer.view.unproject(this._view.stage.screenX, this._view.stage.screenY, 1000))
            .y;
    };
    AVMStage.prototype.getLocalTouchPoints = function (node) {
        var localPosition;
        var localTouchPoints = new Array();
        var len = this._view.stage.touchPoints.length;
        for (var i = 0; i < len; i++) {
            localPosition = node
                .getInverseMatrix3D()
                .transformVector(this._renderer.view.unproject(this._view.stage.touchPoints[i].x, this._view.stage.touchPoints[i].y, 1000));
            localTouchPoints.push(new TouchPoint(localPosition.x, localPosition.y, this._view.stage.touchPoints[i].id));
        }
        return localTouchPoints;
    };
    AVMStage.prototype.unprojectPoint = function (point, targetCoordinateSpace) {
        var localPosition = this._view.getNode(targetCoordinateSpace)
            .getInverseMatrix3D()
            .transformVector(this._view.unproject(point.x, point.y, 1000));
        return new Point(localPosition.x, localPosition.y);
    };
    Object.defineProperty(AVMStage.prototype, "scaleMode", {
        get: function () {
            return this._scaleMode;
        },
        set: function (value) {
            if (!this._scaleModeAllowUpdate)
                return;
            this._scaleMode = value;
            this.resizeStageInternal(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "showFrameRate", {
        get: function () {
            return this._showFrameRate;
        },
        set: function (value) {
            var _this = this;
            if (value == this._showFrameRate)
                return;
            this._showFrameRate = value;
            if (value) {
                // todo: better make this a class that can show more info (like num of drawcalls etc)
                this._fpsTextField = document.createElement('div'); // disable in RC
                this._fpsTextField.style.cssFloat = 'none';
                this._fpsTextField.style.backgroundColor = '#000';
                this._fpsTextField.style.position = 'fixed';
                this._fpsTextField.style.top = '5px';
                this._fpsTextField.style.width = '100px';
                this._fpsTextField.style.height = '20px';
                this._fpsTextField.style.right = '5px';
                this._fpsTextField.style.textAlign = 'center';
                this._fpsTextField.style.color = '#ffffff';
                this._fpsTextField.style.fontSize = '16';
                this._fpsTextField.style.visibility = 'hidden';
                this._fpsTextField.innerHTML = '';
                document.body.appendChild(this._fpsTextField);
                this._showFrameRateIntervalID = window.setInterval(function () { return _this.updateFPS(); }, 999);
            }
            else {
                if (this._showFrameRateIntervalID != -1) {
                    clearInterval(this._showFrameRateIntervalID);
                    this._showFrameRateIntervalID = -1;
                    document.body.removeChild(this._fpsTextField);
                    this._fpsTextField = null;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "stageHeight", {
        get: function () {
            return this._stageHeight;
        },
        set: function (value) {
            this._stageHeight = value;
            this.resizeCallback();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AVMStage.prototype, "stageWidth", {
        get: function () {
            return this._stageWidth;
        },
        set: function (value) {
            this._stageWidth = value;
            this.resizeCallback();
        },
        enumerable: false,
        configurable: true
    });
    AVMStage.runtimeStartTime = 0;
    AVMStage._instance = null;
    AVMStage.forceINT = false;
    return AVMStage;
}(EventDispatcher));
export { AVMStage };
